import styled from 'helpers/styles';
import PropTypes from 'prop-types';
import ComponentStyles from 'styles/mixins/Component.styles';
import ListField from 'components/molecules/Fields/ListField/ListField';
import utils from 'helpers/utils';

const StyledIconField = styled(ListField)
  .attrs((props) => {
    let attr = props;

    const vars = {
      '--icon-field-min-width': props.theme.layout(props.$minWidth ?? 100),
      '--icon-field-columns': `${props.$columns}`,
      '--icon-field-rows': `${props.$rows}`
    };

    return utils.styleProps(attr, vars);
  })`
  &.IconField {
    min-width: ${props => props.$css.$var('--icon-field-min-width', false)};
    .List {
      display: grid;
      grid-auto-flow: row;
      grid-template-columns: repeat(${props => props.$css.$var('--icon-field-columns', false)}, 1fr);
      grid-template-rows: repeat(${props => props.$css.$var('--icon-field-rows', false)}, 1fr);
      gap: ${props => props.theme.layout('0.5sp')};
    }
  }
  ${ComponentStyles}
`;

StyledIconField.propTypes = {
  theme: PropTypes.object
};

export default StyledIconField;
